import { Col, Flex, Grid, TextInput, Text } from '@tremor/react';
import { OutlinedButton } from '../../Buttons/OutlinedButton/OutlinedButton';
import s from './DataForSeoConfigTab.module.scss';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useGetPermissionsLevels } from '@/utils/helpers';
import { PermissionType } from '@/types/auth';
import { SaveIcon } from '@/assets';

interface Props {
  locationCode: number;
  timezone: string;
  register: UseFormRegister<{ name: string }>;
  isLoading: boolean;
  onSave: () => void;
  errors: FieldErrors<{
    name: string;
  }>;
}

export function DataForSeoConfigTab({
  locationCode,
  timezone,
  register,
  onSave,
  isLoading,
  errors,
}: Props) {
  const [, isEditor] = useGetPermissionsLevels(PermissionType.Workspace);
  return (
    <div style={{ borderRadius: '8px' }}>
      <Grid numCols={4} className={s.container}>
        <Col numColSpan={1} className={s.detailsItem}>
          <Text className={s.itemTitle}>Name</Text>
        </Col>
        <Col numColSpan={3} className={s.detailsItem}>
          <form onSubmit={onSave}>
            <Flex justifyContent="start">
              <TextInput
                {...register('name')}
                className={s.workspaceNameInput}
                disabled={isLoading || !isEditor}
                error={!!errors.name}
                errorMessage={errors.name?.message}
              />
              <OutlinedButton
                isLoading={isLoading}
                disabled={!isEditor}
                icon={SaveIcon}
                type="submit"
                iconAltText={'Save icon'}
                style={{ marginLeft: '1rem' }}
              >
                Save
              </OutlinedButton>
            </Flex>
          </form>
        </Col>
        <Col numColSpan={1} className={s.detailsItem}>
          <Text className={s.itemTitle}>Location Code</Text>
        </Col>
        <Col numColSpan={3} className={s.detailsItem}>
          <form onSubmit={onSave}>
            <Flex justifyContent="start">
              <TextInput
                className={s.workspaceNameInput}
                value={locationCode.toString()}
                disabled
              />
            </Flex>
          </form>
        </Col>
        <Col numColSpan={1} className={s.detailsItem}>
          <Text className={s.itemTitle}>Timezone</Text>
        </Col>
        <Col numColSpan={3} className={s.detailsItem}>
          <form onSubmit={onSave}>
            <Flex justifyContent="start">
              <TextInput className={s.workspaceNameInput} value={timezone} disabled />
            </Flex>
          </form>
        </Col>
      </Grid>
    </div>
  );
}
